import { lazy } from "react";

const DashboardLayout = lazy(() => import("./DashboardLayout"));
const SuperAdminDashboardLayout = lazy(
    () => import("./SuperAdminDashboardLayout")
);

export { SuperAdminDashboardLayout, DashboardLayout };
